var $e5e6a3fe3b4527df$exports = {};
$e5e6a3fe3b4527df$exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " a ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " selecionado");
  },
  "finishRangeSelectionPrompt": "Clique para concluir a sele\xE7\xE3o do intervalo de datas",
  "maximumDate": "\xDAltima data dispon\xEDvel",
  "minimumDate": "Primeira data dispon\xEDvel",
  "next": "Pr\xF3ximo",
  "previous": "Anterior",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Data selecionada: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Intervalo selecionado: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Clique para iniciar a sele\xE7\xE3o do intervalo de datas",
  "todayDate": function todayDate(args) {
    return "Hoje, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Hoje, ".concat(args.date, " selecionado");
  }
};
export { $e5e6a3fe3b4527df$exports as default };